module.exports = __webpack_public_path__ + "static/img/service_h5_02_zh.d83445d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service/service_h5_02_zh.png
// module id = pO5F
// module chunks = 34